import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import InstaTable from './InstaTable'

import {
  users_index,
  reset_user,
  clear_user,
  resend_invitation,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.user
  return {
    user: state.user,
    users: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    setStatus: state.user.set_status
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getUsers: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( users_index(page, per_page, filters, sort, order) ),
    resendInvitation: (user_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(resend_invitation(user_id, index, page, per_page, filters, sort, order)),
    resetUser: () => dispatch( reset_user() ),
    clearUser: () => dispatch( clear_user() ),

  }
}

class ConnectedUsersIndex extends React.Component {
  state={
    current_user: null,
    current_view: 'all',
    merge_filters: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    const { active, locked, confirmed } = item
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters,
        type: this.props.userbase,
      }
    }
    let renderText
    if (field === "created_at" || field === "updated_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if ( field === "status" ) {
      let theStatus
      if ( active && !locked && confirmed) {
        theStatus = "active"
      } else if ( locked ) {
        theStatus = "locked"
      } else if ( !confirmed ) {
        theStatus = "pending"
      } else if ( !active && confirmed ) {
        theStatus = "revoked"
      }
      renderText = this.statusIcon(theStatus)
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'name') {
      renderText = (
        <div>
          <div className="td-user-email">{item.email}</div>
          <div className="td-user-name">{item.name} {item.surname}</div>
        </div>
      )
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          {(!confirmed) && this.resendLink(item, state)}
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getUsers, userbase} = this.props
    let initFilters = {
      ...this.state.merge_filters,
      type: userbase || ""
    }

    getUsers(1, 10, initFilters, '', '')

  }

  componentWillUnmount() {
    this.props.resetUser()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (!this.props.user.fetching && this.props.user.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  statusIcon = status => {
    if (status === 'active') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Active">person_outline</Icon>
    } else if (status === 'locked') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Locked Out">lock</Icon>
    } else if (status === 'pending') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Pending">hourglass_empty</Icon>
    } else if (status === 'revoked') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Blocked">block</Icon>
    }
  }

  resendLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Resend Invitation" onClick={e=>{
        e.preventDefault()
        this.props.resendInvitation(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>mail</Icon>
      </Link>
    )
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { pagination, users, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'name', disablePadding: true, label: 'User' },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]
    const filterControls = [
      { name: "search", filter_type: "search" }
    ]
    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Active", value: totals.active },
      { name: "locked", label: "Locked", value: totals.locked },
      { name: "pending", label: "Pending", value: totals.pending },
      { name: "revoked", label: "Blocked", value: totals.revoked },
    ]

    return (
      <div id="users-wrapper" className={this.props.user.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            {this.props.header}
          </Typography>

        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={users}
          pagination={pagination}
          search={true}
          placeholders={"ID, name, email"}
          userRole={'client'}
          merge_filters={{
            ...this.state.merge_filters,
            type: this.props.userbase,
          }}
          rowGetter={this.props.getUsers.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          previewColumn=""
          clearItem={this.props.clearUser.bind(this)}
          classPrefix="user"
          addClassField="status"
          hideFilters={true}
        />

      </div>
    )
  }
}

const UsersIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedUsersIndex)

export default withStyles(styles)(UsersIndex)



// WEBPACK FOOTER //
// ./src/js/components/UsersIndex.js